module.exports = __webpack_public_path__ + "static/media/placeholder-story.f6727f6d.svg";